import restaurant01 from "./../img/restaurant/1.svg";
import restaurant02 from "./../img/restaurant/2.svg";
import restaurant03 from "./../img/restaurant/3.svg";
import restaurant04 from "./../img/restaurant/4.svg";
import restaurant05 from "./../img/restaurant/5.svg";
import restaurant06 from "./../img/restaurant/6.svg";
import restaurant07 from "./../img/restaurant/7.svg";
import restaurant08 from "./../img/restaurant/8.svg";
import restaurant09 from "./../img/restaurant/9.svg";

import restaurant01Big from "./../img/restaurant/01-big.jpg";
import restaurant02Big from "./../img/restaurant/02-big.jpg";
import restaurant03Big from "./../img/restaurant/03-big.jpg";
import restaurant04Big from "./../img/restaurant/04-big.jpeg";
import restaurant05Big from "./../img/restaurant/05-big.png";
import restaurant06Big from "./../img/restaurant/06-big.jpg";
import restaurant07Big from "./../img/restaurant/07-big.jpg";
import restaurant08Big from "./../img/restaurant/08-big.jpeg";
import restaurant09Big from "./../img/restaurant/09-big.jpg";

import fries from "./../img/restaurant/dishes/fries.jpg";
import bbq_wings from "./../img/restaurant/dishes/bbq_wings.jpg";
import onion_rings from "./../img/restaurant/dishes/onion_rings.jpg";
import mozzarella_sticks from "./../img/restaurant/dishes/mozzarella_sticks.jpg";
import baked_mushrooms from "./../img/restaurant/dishes/baked_mushrooms.jpg";
import caesar_salad from "./../img/restaurant/dishes/caesar_salad.jpg";
import greek_salad from "./../img/restaurant/dishes/greek_salad.jpg";
import avocado_shrimp_salad from "./../img/restaurant/dishes/avocado_shrimp_salad.jpg";
import tuna_salad from "./../img/restaurant/dishes/tuna_salad.jpg";
import mango_chicken_salad from "./../img/restaurant/dishes/mango_chicken_salad.jpg";
import borscht from "./../img/restaurant/dishes/borscht.jpg";
import mushroom_soup from "./../img/restaurant/dishes/mushroom_soup.jpg";
import tomato_soup from "./../img/restaurant/dishes/tomato_soup.jpg";
import ramen_soup from "./../img/restaurant/dishes/ramen_soup.jpg";
import pea_soup from "./../img/restaurant/dishes/pea_soup.jpg";
import steak from "./../img/restaurant/dishes/steak.jpg";
import chicken_roll from "./../img/restaurant/dishes/chicken_roll.jpg";
import pork_ribs from "./../img/restaurant/dishes/pork_ribs.jpg";
import grilled_salmon from "./../img/restaurant/dishes/grilled_salmon.jpg";
import grilled_veggies from "./../img/restaurant/dishes/grilled_veggies.jpg";
import mashed_potatoes from "./../img/restaurant/dishes/mashed_potatoes.jpg";
import rice_with_veggies from "./../img/restaurant/dishes/rice_with_veggies.jpg";
import fried_potatoes from "./../img/restaurant/dishes/fried_potatoes.jpg";
import bulgur_with_nuts from "./../img/restaurant/dishes/bulgur_with_nuts.jpg";
import buckwheat_mushrooms from "./../img/restaurant/dishes/buckwheat_mushrooms.jpg";
import chocolate_fondant from "./../img/restaurant/dishes/chocolate_fondant.jpg";
import raspberry_cheesecake from "./../img/restaurant/dishes/raspberry_cheesecake.jpg";
import vanilla_pudding from "./../img/restaurant/dishes/vanilla_pudding.jpg";
import strawberry_tart from "./../img/restaurant/dishes/strawberry_tart.jpg";
import ice_cream from "./../img/restaurant/dishes/ice_cream.jpg";

const menuTest = [
  {
    category: "snacks",
    categoryTitle: "Закуски",
    items: [
      {
        title: "Картофель Фри",
        description: "Спелые картофельные ломтики, обжаренные в масле.",
        price: "120 ₽",
        img: fries,
      },
      {
        title: "Крылья Барбекю",
        description: "Аппетитные куриные крылья со сладким соусом барбекю.",
        price: "180 ₽",
        img: bbq_wings,
      },
      {
        title: "Луковые кольца",
        description: "Хрустящие ломтики лука во фритюре, подается с соусом.",
        price: "150 ₽",
        img: onion_rings,
      },
      {
        title: "Моцарелла-Стрипсы",
        description:
          "Сырные палочки с моцареллой, обжаренные до золотистой корки.",
        price: "160 ₽",
        img: mozzarella_sticks,
      },
      {
        title: "Запеченные Грибы",
        description: "Свежие грибы, запеченные с сыром и травами.",
        price: "190 ₽",
        img: baked_mushrooms,
      },
      {
        title: "Картофель Фри",
        description: "Спелые картофельные ломтики, обжаренные в масле.",
        price: "120 ₽",
        img: fries,
      },
      {
        title: "Крылья Барбекю",
        description: "Аппетитные куриные крылья со сладким соусом барбекю.",
        price: "180 ₽",
        img: bbq_wings,
      },
      {
        title: "Луковые кольца",
        description: "Хрустящие ломтики лука во фритюре, подается с соусом.",
        price: "150 ₽",
        img: onion_rings,
      },
      {
        title: "Моцарелла-Стрипсы",
        description:
          "Сырные палочки с моцареллой, обжаренные до золотистой корки.",
        price: "160 ₽",
        img: mozzarella_sticks,
      },
      {
        title: "Запеченные Грибы",
        description: "Свежие грибы, запеченные с сыром и травами.",
        price: "190 ₽",
        img: baked_mushrooms,
      },
    ],
  },
  {
    category: "salads",
    categoryTitle: "Салаты",
    items: [
      {
        title: "Цезарь с курицей",
        description:
          "Салат с кусочками сочной куриной грудки и ароматным соусом Цезарь.",
        price: "280 ₽",
        img: caesar_salad,
      },
      {
        title: "Греческий салат",
        description:
          "Традиционный салат с оливками, огурцами, помидорами и сыром фета.",
        price: "250 ₽",
        img: greek_salad,
      },
      {
        title: "Салат с авокадо и креветками",
        description:
          "Салат с нарезанным авокадо, креветками и свежими овощами.",
        price: "320 ₽",
        img: avocado_shrimp_salad,
      },
      {
        title: "Салат с тунцом",
        description: "Свежий салат с кусочками тунца, яйцами и оливками.",
        price: "300 ₽",
        img: tuna_salad,
      },
      {
        title: "Салат с манго и куриной грудкой",
        description: "Салат с сочной куриной грудкой, манго и орехами.",
        price: "290 ₽",
        img: mango_chicken_salad,
      },
      {
        title: "Цезарь с курицей",
        description:
          "Салат с кусочками сочной куриной грудки и ароматным соусом Цезарь.",
        price: "280 ₽",
        img: caesar_salad,
      },
      {
        title: "Греческий салат",
        description:
          "Традиционный салат с оливками, огурцами, помидорами и сыром фета.",
        price: "250 ₽",
        img: greek_salad,
      },
      {
        title: "Салат с авокадо и креветками",
        description:
          "Салат с нарезанным авокадо, креветками и свежими овощами.",
        price: "320 ₽",
        img: avocado_shrimp_salad,
      },
      {
        title: "Салат с тунцом",
        description: "Свежий салат с кусочками тунца, яйцами и оливками.",
        price: "300 ₽",
        img: tuna_salad,
      },
      {
        title: "Салат с манго и куриной грудкой",
        description: "Салат с сочной куриной грудкой, манго и орехами.",
        price: "290 ₽",
        img: mango_chicken_salad,
      },
    ],
  },
  {
    category: "soups",
    categoryTitle: "Супы",
    items: [
      {
        title: "Борщ",
        description: "Традиционный украинский борщ с мясом и свежими овощами.",
        price: "180 ₽",
        img: borscht,
      },
      {
        title: "Крем-суп из шампиньонов",
        description: "Нежный крем-суп с ароматными шампиньонами.",
        price: "190 ₽",
        img: mushroom_soup,
      },
      {
        title: "Томатный суп",
        description: "Ароматный томатный суп с базиликом и сливками.",
        price: "170 ₽",
        img: tomato_soup,
      },
      {
        title: "Лапша Рамен",
        description: "Азиатский суп с кусочками мяса, овощами и лапшой Рамен.",
        price: "220 ₽",
        img: ramen_soup,
      },
      ,
      {
        title: "Гороховый суп",
        description: "Традиционный гороховый суп с копченостями.",
        price: "160 ₽",
        img: pea_soup,
      },
      {
        title: "Борщ",
        description: "Традиционный украинский борщ с мясом и свежими овощами.",
        price: "180 ₽",
        img: borscht,
      },
      {
        title: "Крем-суп из шампиньонов",
        description: "Нежный крем-суп с ароматными шампиньонами.",
        price: "190 ₽",
        img: mushroom_soup,
      },
      {
        title: "Томатный суп",
        description: "Ароматный томатный суп с базиликом и сливками.",
        price: "170 ₽",
        img: tomato_soup,
      },
      {
        title: "Лапша Рамен",
        description: "Азиатский суп с кусочками мяса, овощами и лапшой Рамен.",
        price: "220 ₽",
        img: ramen_soup,
      },
      ,
      {
        title: "Гороховый суп",
        description: "Традиционный гороховый суп с копченостями.",
        price: "160 ₽",
        img: pea_soup,
      },
    ],
  },
  {
    category: "main_dishes",
    categoryTitle: "Горячие блюда",
    items: [
      {
        title: "Стейк из говядины",
        description: "Сочный нежный стейк из мраморной говядины.",
        price: "450 ₽",
        img: steak,
      },
      {
        title: "Куриный ролл",
        description:
          "Сочный ролл с куриной грудкой и овощами, подается с соусом.",
        price: "320 ₽",
        img: chicken_roll,
      },
      {
        title: "Свиные ребрышки",
        description:
          "Пикантные свиные ребрышки, запеченные в специальном соусе.",
        price: "380 ₽",
        img: pork_ribs,
      },
      {
        title: "Лосось на гриле",
        description:
          "Сочный лосось, приготовленный на гриле с ароматными специями.",
        price: "420 ₽",
        img: grilled_salmon,
      },
      {
        title: "Шашлык из овощей",
        description: "Ассорти из гриль-овощей с ароматными травами и специями.",
        price: "250 ₽",
        img: grilled_veggies,
      },
      {
        title: "Стейк из говядины",
        description: "Сочный нежный стейк из мраморной говядины.",
        price: "450 ₽",
        img: steak,
      },
      {
        title: "Куриный ролл",
        description:
          "Сочный ролл с куриной грудкой и овощами, подается с соусом.",
        price: "320 ₽",
        img: chicken_roll,
      },
      {
        title: "Свиные ребрышки",
        description:
          "Пикантные свиные ребрышки, запеченные в специальном соусе.",
        price: "380 ₽",
        img: pork_ribs,
      },
      {
        title: "Лосось на гриле",
        description:
          "Сочный лосось, приготовленный на гриле с ароматными специями.",
        price: "420 ₽",
        img: grilled_salmon,
      },
      {
        title: "Шашлык из овощей",
        description: "Ассорти из гриль-овощей с ароматными травами и специями.",
        price: "250 ₽",
        img: grilled_veggies,
      },
    ],
  },
  {
    category: "side_dishes",
    categoryTitle: "Гарниры",
    items: [
      {
        title: "Картофельное пюре",
        description: "Нежное пюре со сливками.",
        price: "150 ₽",
        img: mashed_potatoes,
      },
      {
        title: "Рис с овощами",
        description:
          "Паровой рис с молодыми овощами и легким ароматным соусом.",
        price: "130 ₽",
        img: rice_with_veggies,
      },
      {
        title: "Жареная картошка",
        description: "Хрустящая картошка, обжаренная с травами и специями.",
        price: "140 ₽",
        img: fried_potatoes,
      },
      {
        title: "Булгур с орехами",
        description: "Паровой булгур с ароматными орехами и зеленью.",
        price: "160 ₽",
        img: bulgur_with_nuts,
      },
      {
        title: "Гречка с Грибами",
        description: "Отварная гречка с жареными грибами и луком.",
        price: "170 ₽",
        img: buckwheat_mushrooms,
      },
      {
        title: "Картофельное пюре",
        description: "Нежное пюре со сливками.",
        price: "150 ₽",
        img: mashed_potatoes,
      },
      {
        title: "Рис с овощами",
        description:
          "Паровой рис с молодыми овощами и легким ароматным соусом.",
        price: "130 ₽",
        img: rice_with_veggies,
      },
      {
        title: "Жареная картошка",
        description: "Хрустящая картошка, обжаренная с травами и специями.",
        price: "140 ₽",
        img: fried_potatoes,
      },
      {
        title: "Булгур с орехами",
        description: "Паровой булгур с ароматными орехами и зеленью.",
        price: "160 ₽",
        img: bulgur_with_nuts,
      },
      {
        title: "Гречка с Грибами",
        description: "Отварная гречка с жареными грибами и луком.",
        price: "170 ₽",
        img: buckwheat_mushrooms,
      },
      ,
    ],
  },
  {
    category: "desserts",
    categoryTitle: "Десерты",
    items: [
      {
        title: "Шоколадный фондан",
        description: "Пирожное с жидкой шоколадной сердцевиной.",
        price: "220 ₽",
        img: chocolate_fondant,
      },
      {
        title: "Чизкейк с малиной",
        description: "Нежный чизкейк с тонким слоем малинового желе.",
        price: "250 ₽",
        img: raspberry_cheesecake,
      },
      {
        title: "Ванильный пудинг",
        description: "Ароматный ванильный пудинг с карамельным соусом.",
        price: "180 ₽",
        img: vanilla_pudding,
      },
      {
        title: "Клубничный тарт",
        description: "Тарт с заварным кремом и свежими клубникой.",
        price: "280 ₽",
        img: strawberry_tart,
      },
      {
        title: "Мороженое",
        description: "Две порции мороженого по вашему выбору с топпингами.",
        price: "160 ₽",
        img: ice_cream,
      },
      {
        title: "Шоколадный фондан",
        description: "Пирожное с жидкой шоколадной сердцевиной.",
        price: "220 ₽",
        img: chocolate_fondant,
      },
      {
        title: "Чизкейк с малиной",
        description: "Нежный чизкейк с тонким слоем малинового желе.",
        price: "250 ₽",
        img: raspberry_cheesecake,
      },
      {
        title: "Ванильный пудинг",
        description: "Ароматный ванильный пудинг с карамельным соусом.",
        price: "180 ₽",
        img: vanilla_pudding,
      },
      {
        title: "Клубничный тарт",
        description: "Тарт с заварным кремом и свежими клубникой.",
        price: "280 ₽",
        img: strawberry_tart,
      },
      {
        title: "Мороженое",
        description: "Две порции мороженого по вашему выбору с топпингами.",
        price: "160 ₽",
        img: ice_cream,
      },
    ],
  },
];

const restaurants = [
  {
    title: "Макдоналдс — Газетный",
    type: "Бургеры • Американская",
    price: "₽₽",
    img: restaurant01,
    imgBig: restaurant01Big,
    time: "25 - 35 мин",
    menu: menuTest,
  },
  {
    title: "DimSum & Co — ЦДМ",
    type: "Японская • Китайская • Азиатская",
    price: "₽",
    img: restaurant02,
    imgBig: restaurant02Big,
    time: "40 - 50 мин",
    menu: menuTest,
  },
  {
    title: "ДвижОК — Манежная",
    type: "Американская • Европейская",
    price: "₽",
    img: restaurant03,
    imgBig: restaurant03Big,
    time: "35 - 45 мин",
    menu: menuTest,
  },
  {
    title: "НЯ — NHA",
    type: "Вьетнамская • Азиатская",
    price: "₽₽",
    img: restaurant04,
    imgBig: restaurant04Big,
    time: "30 - 40 мин",
    menu: menuTest,
  },
  {
    title: "Точка Дзы — Цветной",
    type: "Вьетнамская • Азиатская",
    price: "₽₽",
    img: restaurant05,
    imgBig: restaurant05Big,
    time: "40 - 50 мин",
    menu: menuTest,
  },
  {
    title: "Cinnabon",
    type: "Выпечка • Десерты • Капкейки",
    price: "₽",
    img: restaurant06,
    imgBig: restaurant06Big,
    time: "25 - 35 мин",
    menu: menuTest,
  },
  {
    title: "PIZZELOVE",
    type: "Пицца • Итальянская • Европейская",
    price: "₽₽",
    img: restaurant07,
    imgBig: restaurant07Big,
    time: "15 - 25 мин",
    menu: menuTest,
  },
  {
    title: "Zю кафе — Тверская",
    type: "Японская • Азиатская",
    price: "₽₽",
    img: restaurant08,
    imgBig: restaurant08Big,
    time: "25 - 35 мин",
    menu: menuTest,
  },
  {
    title: "Bar BQ Cafe — Манежная",
    type: "Американская • Европейская",
    price: "₽₽₽",
    img: restaurant09,
    imgBig: restaurant09Big,
    time: "30 - 40 мин",
    menu: menuTest,
  },
];

export { restaurants };
